import {Currency} from "@/enums/Currency";
import {Locale} from "@/enums/Locale";

import localeCurrency from "@/data/localeCurrency";
import currencySign from "@/data/currencySign";

export function formatPriceByCurrency(price:number, currency:Currency) {
  let priceString = price.toFixed(2);

  if(currency == Currency.EURO) {
    priceString = priceString.replace('.',',')
  }

  if(currency == Currency.CHF) {
    priceString = priceString.replace('.',',')
  }

  return `${priceString} ${currencySign[currency]}`
}

export function formatPriceByLocale(price: number, locale: Locale): string {
  const currency = localeCurrency[locale] || Currency.EURO;
  return formatPriceByCurrency(price, currency)
}
